<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label-is-up="labelIsUp"
      :label="$attrs.label"
      :no-label="noLabel"
      :no-asterisk="noAsterisk"
      :hint="$attrs.hint"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
      :margin="$attrs.margin"
    >
      <template #label>
        <slot name="label" />
      </template>
      <input
        :id="id"
        v-model="model"
        :class="[{'is-invalid': !valid && validated}, `form-control-${$attrs.size}`]"
        :name="name"
        v-bind="$attrs"
        class="form-control"
        v-on="listeners"
      >
      <span
        v-if="$attrs.hint"
        class="hint"
      >{{ $attrs.hint }}</span>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import basicComponentMixin from './basic-component-mixin.js'
export default {
  name: 'BasicInput',
  mixins: [basicComponentMixin],
  props: {
    noAsterisk: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    }
  }
}
</script>
